module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BookItalic.ba0f9e9f.eot";